<template>
    <div id="event-edit">
        <fluke-card>
            <header v-if="permission.write">
                <div class="title">Editar Evento</div>
                <div class="description">Altere as informações do evento</div>
            </header>
            <header v-else>
                <div class="title">Visualizar Evento</div>
                <div class="description">Alterações desabilitadas para este perfil</div>
            </header>
            <main>

                <div class="flexsplit">
                    <div>
                        <v-dialog
                            ref="dialogDate"
                            v-model="modalDate"
                            :return-value.sync="date"
                            persistent
                            lazy
                            full-width
                            :hide-overlay="true"
                            width="290px">

                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="formatedDate"
                                    label="Escolha o dia"
                                    prepend-icon="event"
                                    readonly
                                    v-on="on">
                                </v-text-field>
                            </template>

                            <v-date-picker v-model="date" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="white" @click="modalDate = false">Cancelar</v-btn>
                                <v-btn flat color="white" @click="$refs.dialogDate.save(date)">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                        <v-text-field label="Nome" v-model="title" :disabled="permission.write?null:true" maxlength="60"></v-text-field>
                        <v-text-field label="Descrição" v-model="description" :disabled="permission.write?null:true" maxlength="60"></v-text-field>
                        <v-text-field label="Link" v-model="link" :disabled="permission.write?null:true"></v-text-field>
                    </div>
                    <div>
                        <fluke-imageuploader
                            :disabled="permission.write?null:true"
                            v-model="img">
                        </fluke-imageuploader>
                        <p class="image-uploader-label">Tamanho recomendado: 360x200px</p>
                    </div>
                </div>
            </main>
            <footer>
                <fluke-button v-on:click.native="cancel" color="grey">cancelar</fluke-button>
                <fluke-button  v-if="permission.write" v-on:click.native="submit">Salvar</fluke-button>
            </footer>
        </fluke-card>

        <div class="right" v-if="permission.write">
            <a v-on:click="remove" class="remove-links">Remover Evento</a>
        </div>
        <global-popup ref="remove" title="Remover">Deseja remover o evento?</global-popup>
    </div>
</template>

<script>
import axios from 'axios';

import Card from '../../components/Main/Content/Card/Card.vue';
import Button from '../../components/Main/Content/Button/Button.vue';
import ImageUploader from '../../components/Main/Content/ImageUploader/ImageUploader';

import permission from '../../mixins/permissions';


export default {
    mixins: [ permission ],
    components: {
        'fluke-card': Card,
        'fluke-button': Button,
        'fluke-imageuploader': ImageUploader
    },
    data: function() {
        return {
            id: null,
            title: '',
            modalDate: false,
            date: '',
            description: '',
            link: '',
            img: '',
            permission: {
                read: false,
				write: false
			}
        }
    },
    computed: {
        formatedDate() {
            return this.date.split('-').reverse().join('/');
        }
    },
    created: function(){
        this.getData();
        this.permission = this.getUserPagePermission('events');
		if( this.permission.read == false ) {
			this.$router.push('/');
		}
    },
    methods: {
        getData: async function(){
            this.id = this.$route.params.id;
            const result = await axios.get(
				this.$myServerAddresses.events + 'events/' + this.id, {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            this.title = result.data.title;
            this.description = result.data.description;
            this.img = result.data.img;
            this.link = result.data.link;

            this.date = result.data.beginDate.split('T')[0];
        },
        submit: async function() {
            const result = await axios.put(
				this.$myServerAddresses.events + 'events',
				{
                    id: this.id,
                    title: this.title,
                    description: this.description,
                    beginDate: this.date,
                    img: this.img,
                    link: this.link
				},
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            this.$router.push({ name: 'events' });
        },
        remove: async function () {
            this.$refs.remove
                .confirm()
                .then(()=>{
                    axios.delete(
                        this.$myServerAddresses.events + 'events/' + this.id,
                        {
                            headers: {
                                'X-Fluke': this.$cookies.get('token')
                            }
                        }
                    )
                    .then(()=>{
                        this.$router.push({ name: 'events' });
                    });
                });
        },
        cancel() {
            this.$router.push({ name: 'events' });
        }
    }
}
</script>

<style lang="scss">
#event-edit
{
    .iu-content.active,
    .iu-placeholder.active
    {
        height: 235px;
    }
}

p.image-uploader-label {
    text-align: center;
    font-style: italic;
}
</style>
